const QuoteMark = () => (
  <svg
    width="36"
    height="28"
    viewBox="0 0 36 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="text-[#C9587E]/40 mb-4"
    aria-hidden="true"
  >
    <path
      d="M15.04 0L9.6 11.2H14.4V28H0V11.2L5.44 0H15.04ZM36 0L30.56 11.2H35.36V28H20.96V11.2L26.4 0H36Z"
      fill="currentColor"
    />
  </svg>
);

export const TestimonialBar = ({ testimonials, testid = "testimonial-bar" }) => {
  const cols =
    testimonials.length === 1
      ? "lg:grid-cols-1 max-w-3xl mx-auto"
      : testimonials.length === 2
      ? "md:grid-cols-2 max-w-5xl mx-auto"
      : "md:grid-cols-2 lg:grid-cols-3";

  return (
    <div className="relative" data-testid={testid}>
      <div className={`grid grid-cols-1 ${cols} gap-6 md:gap-8`}>
        {testimonials.map((t, i) => (
          <figure
            key={i}
            className="relative rounded-2xl border border-[#EDD9DE] bg-[#FFFCFB] p-8 md:p-10 flex flex-col shadow-ambient"
            data-testid={`${testid}-card-${i}`}
          >
            <QuoteMark />
            <blockquote className="font-serif italic text-lg md:text-xl text-[#3B2630] leading-relaxed flex-grow">
              {t.quote}
            </blockquote>
            {t.attribution && (
              <figcaption className="mt-6 pt-6 border-t border-[#EDD9DE] font-body uppercase tracking-[0.25em] text-[10px] text-[#C9587E] font-semibold">
                {t.attribution}
              </figcaption>
            )}
          </figure>
        ))}
      </div>
    </div>
  );
};
